import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Modal, Button, Input, Select } from "antd";
import {
  UpdateProfileShortListingDetails,
  updateProfileShortListingDetails,
} from "../../HttpRequest/issues";
const MyForm = ({ isVisible, onCancel, data }) => {
  console.log(data);
  const {
    handleSubmit,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm();
  const [isFieldDisabled, setIsFieldDisabled] = useState(true);


  const onSubmit = (data) => {
    console.log(data);
    // Perform your form submission logic here
    onCancel(); // Close the modal after submission
  };

  const handleStatusChange = (selectedStatus) => {
    console.log("Selected status ===>", selectedStatus);
    const updatedData = {
      ...data,
      status: selectedStatus,
    };
    console.log("Updated Data===>", updatedData);
    updateProfileShortListingDetails(updatedData.id, updatedData)
      .then((response) => {
        loadData(response.data);
        console.log("API call successful:", response.data);
      })
      .catch((error) => {
        console.error("API call error:", error);
      });
  };

  useEffect(() => {
    loadData(data);
  }, [data, setValue]);

  const loadData = (data) => {
    if (data) {
      Object.keys(data).forEach((id) => {
        setValue(id, data[id]);
      });
    }
  };

  return (
    <Modal visible={isVisible} onCancel={onCancel} footer={null}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex" style={{ justifyContent: "space-between",marginRight: "10%" }}>
          <div>
            <div>
              <Controller
                name="name"
                control={control}
                rules={{ required: "Name is required." }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">Name</p>
                    <Input
                      {...field}
                      placeholder="Enter your name"
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />

                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />

              <div>
                <div>
                  <p className="profileShortListingp">Country</p>
                  <Controller
                    name="country"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <>
                        <select
                          {...field}
                          value={field.value}
                          onChange={(e) => field.onChange(e)}
                          disabled={isFieldDisabled}
                        >
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="United States Of America">
                            United States Of America
                          </option>
                          <option value="Canada">Canada</option>
                          <option value="Australia">Australia</option>
                          <option value="Finland">Finland</option>
                          <option value="New Zealand">New Zealand</option>
                        </select>
                      </>
                    )}
                  />
                </div>
              </div>
              <Controller
                name="course"
                control={control}
                rules={{ required: "Please enter country" }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">Course/Program</p>
                    <Input
                      {...field}
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />
              <Controller
                name="bachelorsPassOut"
                control={control}
                rules={{ required: "Please enter country" }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">
                      Year of Bachelor Graduation
                    </p>
                    <Input
                      {...field}
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />
              <Controller
                name="backlogs"
                control={control}
                rules={{ required: "Please enter country" }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">Backlogs</p>
                    <Input
                      {...field}
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />
              <Controller
                name="englishTest"
                control={control}
                rules={{ required: "Please enter country" }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">
                      Professional English Test
                    </p>
                    <Input
                      {...field}
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />

              <Controller
                name="createdDate"
                control={control}
                rules={{ required: "Date is required." }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">Created On</p>
                    <Input
                      {...field}
                      placeholder="Enter your name"
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />

                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />
            </div>
          </div>
          <div>
            <div className="">
              <Controller
                name="email"
                control={control}
                rules={{ required: "Email is required." }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">Email</p>
                    <Input
                      {...field}
                      placeholder="Enter your name"
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />

                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />
              <div>
                <p className="profileShortListingp">Degree</p>
                <Controller
                  name="select2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <>
                      <select
                        {...field}
                        value={field.value}
                        onChange={(e) => field.onChange(e)}
                        disabled={isFieldDisabled}
                      >
                        <option value="Postgraduate">Postgraduate</option>
                        <option value="Undergraduate">Undergraduate</option>
                        <option value="PhD">PHD</option>
                        <option value="English">English[ESL,IEP,ELP]</option>
                      </select>
                    </>
                  )}
                />
              </div>
              <Controller
                name="interScore"
                control={control}
                rules={{ required: "Please enter country" }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">12th Score</p>
                    <Input
                      {...field}
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />

              <Controller
                name="bachelorScore"
                control={control}
                rules={{ required: "Please enter country" }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">Bachelor's Score</p>
                    <Input
                      {...field}
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />

              <Controller
                name="workExperience"
                control={control}
                rules={{ required: "Please enter country" }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">Work Experience</p>
                    <Input
                      {...field}
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />
              <Controller
                name="englishTestScore"
                control={control}
                rules={{ required: "Please enter country" }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <p className="profileShortListingp">
                      Score in the English Test
                    </p>
                    <Input
                      {...field}
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      disabled={isFieldDisabled}
                    />
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />
              <Controller
                name="status"
                control={control}
                rules={{ required: "Date is required." }}
                render={({ field, fieldState }) => (
                  <div className="profileShortListingdiv">
                    <label className="profileShortListingp">Status:</label>
                    <select
                      value={field.value}
                      onChange={(e) => {
                        field.onChange(e);
                        handleStatusChange(e.target.value);
                      }}
                      // disabled={isFieldDisabled}
                    >
                      <option value="Open">Open</option>
                      <option value="InProgress">In Progress</option>
                      <option value="Closed">Closed</option>
                    </select>
                    <span style={{ color: "red" }}>
                      {fieldState?.error?.message}
                    </span>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default MyForm;
